// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TagChevronBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m30.079 14.614-5.329-8A2.491 2.491 0 0 0 22.665 5.5H3a1.5 1.5 0 0 0-1.235 2.352L7.39 16l-5.625 8.148A1.5 1.5 0 0 0 3 26.5h19.665a2.493 2.493 0 0 0 2.085-1.114l5.334-8a2.492 2.492 0 0 0-.005-2.772ZM22.398 23.5H5.858l4.207-6.093a2.489 2.489 0 0 0 0-2.815L5.859 8.5h16.538l5 7.5-5 7.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
